<template>
    <div>
        <div  class="mt-4">
            <h3>
                    {{ formTemplateData.name }}
                </h3>
        </div>
                    <!-- if its standard BOM form need to show material data -->
                    <div class="fh center" v-if="loading">
                      <loading-circle />
                    </div>
                    <div v-else class="input-group mt-3">
                        <template v-for="(ele, index) in templateField">
                        <component
      v-if="!ele.autogenerated"
      :ref="ele.field_id"
      :key="index"
      :is="ele.form_field.key + '_COMPONENT'"
      :mode="!formValueData ? 'CREATE' : 'EDIT'"
      :data="ele"
      :value="!formValueData ? null : formValueData[ele.field_id]"
      :formTemplate="true"
      :formData="getFieldValue(ele)"
      :templateId="templateId"
      :fieldId="ele.field_id"
      :formTypeId="config.STANDARD_BOM_FORM.form_type"
      :returnObjectValue="true"
      @customChange= "handleInputChange"
    />
                    </template>
                </div>
</div>
</template>

<script>
import { GetStandardBomFormTemplate, getGivenCustomListsData } from '@/api'
import { GetTenantConfigTypes } from '@/api/apis/tenantConfigFeature'
import timeComponent from '@/components/form/elements/timeComponent.vue'
import configurationList from '@/components/form/elements/configurationList.vue'
import fileComponent from '@/components/form/elements/fileComponent.vue'
import dateComponent from '@/components/form/elements/dateComponent.vue'
import longTextComponent from '@/components/form/elements/longTextComponent.vue'
import numberComponent from '@/components/form/elements/numberComponent.vue'
import switchComponent from '@/components/form/elements/switchComponent.vue'
import textComponent from '@/components/form/elements/textComponent.vue'
import companyComponent from '@/components/form/elements/companyComponent.vue'
import userComponent from '@/components/form/elements/userComponent.vue'
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import materialComponent from '@/components/form/elements/materialComponent.vue'
import locationComponent from '@/components/form/elements/locationComponent.vue'
import productCodeComponent from '@/components/form/elements/productCodeComponent.vue'
import LoadingCircle from '../../../components/common/loadingCircle.vue'
import tableTemplate from '@/views/SETTINGS/tableTemplate.vue'
import { mapGetters } from 'vuex'
import config from '@/config'
import { alert } from '@/plugins/notification'
import errorBorder, { removeErrorBorder } from '@/helper/formValidation/errorBorder'
export default {
  name: 'std-Bom-Form',
  components: {
    BOOLEAN_COMPONENT: switchComponent,
    NUMBER_COMPONENT: numberComponent,
    TEXT_COMPONENT: textComponent,
    LONG_TEXT_COMPONENT: longTextComponent,
    DATE_COMPONENT: dateComponent,
    TIME_COMPONENT: timeComponent,
    CONFIGURATION_LIST_COMPONENT: configurationList,
    ATTACHMENT_COMPONENT: fileComponent,
    COMPANY_COMPONENT: companyComponent,
    USER_COMPONENT: userComponent,
    MULTI_USER_COMPONENT: multiUserComponent,
    MATERIALS_COMPONENT: materialComponent,
    LOCATION_COMPONENT: locationComponent,
    PRODUCT_CODE_COMPONENT: productCodeComponent,
    TABLE_COMPONENT: tableTemplate,
    LoadingCircle
  },
  props: {
    stdFormValues: {
      default: null
    },
    createForm: {
      type: Boolean,
      default: false
    },
    stdBomVersionId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      validationErrors: [],
      templateId: '',
      formTemplateData: {},
      loading: true,
      formValueData: null,
      config: config,
      formValue: {} // Holds the updated form values
    }
  },
  computed: {
    ...mapGetters(['tenantDefaultsData']),
    templateField () {
      if (!this.formTemplateData.template_versions) return []
      if (this.stdBomVersionId) {
        // if stdBomVersionId exist find the version and return its fields otherwise return empty array
        // as per the sbm template version  query , it will only contain one version stick to stdBomVersionId
        const currentVersion = this.formTemplateData.template_versions.find((item) => item.id === this.stdBomVersionId)
        return currentVersion ? currentVersion.template_fields : []
      }
      const activeVersion =
        this.formTemplateData.template_versions.find((item) => item.active) ||
        {}
      return activeVersion.template_fields || []
    }
  },
  methods: {
    getValidationSelector (formInput, form) {
      if (!formInput?.field_id) return null
      return form?.[formInput.field_id]?.[0]?.validationName || null
    },
    setInputValidationState (formInput, form, hasError) {
      const selector = this.getValidationSelector(formInput, form)
      if (!selector) return
      if (hasError) {
        errorBorder(selector, true)
      } else {
        removeErrorBorder([selector])
      }
    },
    getFieldValue (ele) {
      if (!this.formValueData) return null
      const value = this.formValueData[ele?.field_id]
      // If it's TABLE → transform structure
      if (ele?.form_field?.key === 'TABLE' && value) {
        return {
          forms_table: [
            {
              table_data: value
            }
          ]
        }
      }
      return value
    },
    async validateInputData () {
      const form = this.$refs
      this.validationErrors = []
      const isTableValid = await this.validateTableInput()
      if (!isTableValid) return null
      for (const key of Object.keys(form)) {
        const fieldInstance = form[key][0]
        if (!fieldInstance) continue
        const formInput = fieldInstance.data
        let hasError = false
        if (formInput?.form_field?.key === 'USER') {
          if (formInput.required && (!fieldInstance.componentValue || !fieldInstance.componentValue.length)) {
            this.validationErrors.push(`${formInput.caption} is a mandatory field`)
            hasError = true
          }
        }
        if (formInput?.form_field?.key === 'BOOLEAN') {
        // we are comparing the value to null instead of checking if it is a falsy value cause the boolean component value will false in one case and it is valid value
          if (formInput.required && fieldInstance.componentValue === null) {
            this.validationErrors.push(`${formInput.caption} is a mandatory field`)
            hasError = true
          }
          this.setInputValidationState(formInput, form, hasError)
          continue
        } else if (formInput?.form_field?.key === 'MATERIALS') {
          if (formInput.required && fieldInstance.componentValue.length < 1) {
            this.validationErrors.push(`${formInput.caption} is a mandatory field`)
            hasError = true
          }
          this.setInputValidationState(formInput, form, hasError)
          continue
        } else if (formInput?.form_field?.key === 'CONFIGURATION_LIST') {
          const configValue = fieldInstance?.componentValue || []
          if (
            formInput.required &&
            (!Array.isArray(configValue) || configValue.length < 1)
          ) {
            this.validationErrors.push(`${formInput.caption} is a mandatory field`)
            hasError = true
          } else if (fieldInstance.validateSelection) {
            const isLeafValid = await fieldInstance.validateSelection()
            if (!isLeafValid) {
              this.validationErrors.push(`Please select the last child value for ${formInput.caption}`)
              hasError = true
            }
          }
          this.setInputValidationState(formInput, form, hasError)
          continue
        }
        if (formInput?.required && !fieldInstance.componentValue) {
          if (!hasError) {
            this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          }
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
      }
      // Emit errors if any
      if (this.validationErrors.length > 0) {
        this.$emit('validationErrors', this.validationErrors) // Ensure this is being emitted
      }
      return this.validationErrors
    },
    async validateTableInput () {
      const form = this.$refs

      for (const key of Object.keys(form)) {
        const field = form[key]?.[0]
        const component = field?.data

        if (component?.form_field?.key === 'TABLE') {
          const isTableValid = await field.saveFormTemplate()

          if (!isTableValid) return false
        }
      }

      return true
    },
    async getGivenCustomList (ids) {
      const customListData = await getGivenCustomListsData(ids)
      const customListMap = {}
      for (const customList of customListData.core_custom_list) {
        customListMap[customList.id] = customList.custom_list_values
      }
      this.$store.dispatch('form/saveCustomListMap', customListMap)
    },
    handleInputChange () {
      const form = this.$refs
      const formValue = {}
      Object.keys(form).forEach((key) => {
        if (form[key].length && form[key][0]?.data?.autogenerated === false) {
          formValue[key] = form[key][0].componentValue
        }
      })
      const inputPayload = this.createForm ? [] : {}
      Object.keys(formValue).forEach((key) => {
        if (formValue[key] !== undefined && formValue[key] !== null) {
          if (formValue[key] !== 0 && formValue[key].length !== 0) {
            if (this.createForm) {
              inputPayload.push({
                field_id: key,
                value: formValue[key]
              })
            } else {
              inputPayload[key] = formValue[key]
            }
          }
        }
      })
      this.$emit('stdBomForm', inputPayload)
    },
    getBomFormTemaplate () {
      this.formValueData = this.stdFormValues
      if (this.tenantDefaultsData.bom_temp_id) {
        this.getStandardBomFormTemplate(this.tenantDefaultsData.bom_temp_id)
      } else {
        GetTenantConfigTypes().then((res) => {
          const tenantDefaults = res.tenant_defaults?.[0]
          this.$store.commit('setTenentDefaults', tenantDefaults)
          this.getStandardBomFormTemplate(tenantDefaults?.tenant_feature_configuration?.BOM?.FORM_TEMPLATE_DEFAULT)
        })
      }
    },
    getStandardBomFormTemplate (tempId) {
      this.loading = true
      GetStandardBomFormTemplate(tempId, this.stdBomVersionId).then(async (res) => {
        this.templateId = res.core_form_templates[0].id
        this.formTemplateData = res.core_form_templates[0]
        const customListData = this.findUsedCustomListIds(res.core_form_templates[0].template_versions)
        if (customListData.size > 0) {
          await this.getGivenCustomList([...customListData])
        }
        this.loading = false
      }).catch(() => {
        alert('Failed to fetch standard BOM form')
      }).finally(() => {
        this.loading = false
      })
    },
    findUsedCustomListIds (templateVersions) {
      const configIdSet = new Set()
      for (const templateVersion of templateVersions) {
        for (const field of templateVersion.template_fields) {
          if (field.field_type_id === config.FORM_TYPE.CONFIGRATION_LIST) {
            configIdSet.add(field.custom_list_id)
          }
        }
      }
      return configIdSet
    }
  },
  mounted () {
    this.getBomFormTemaplate()
  },
  watch: {
    stdFormValues (newVal) {
      if (newVal !== this.formValueData) {
        this.formValueData = newVal
      }
    },
    stdBomVersionId () {
      this.getBomFormTemaplate()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
